import { render, staticRenderFns } from "./PosttypeToggle.vue?vue&type=template&id=8caa007c&"
import script from "./PosttypeToggle.vue?vue&type=script&lang=js&"
export * from "./PosttypeToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports